import isEmpty from 'lodash/isEmpty';

import { VARIANTS } from '@jobcase/react_pattern_library/components/Toaster/Toaster';
import entity from './entity';

import { setNotification } from '../../notification/actions';
import { getProfileKey } from '../../authentication/selectors';

export const TYPES = {
  ...entity.getTypes(),
  CREATE_CART_REQUEST: `${entity.name}/CREATE_CART_REQUEST`,
  CREATE_CART_SUCCESS: `${entity.name}/CREATE_CART_SUCCESS`,
  CREATE_CART_FAILURE: `${entity.name}/CREATE_CART_FAILURE`,
  UPDATE_SPONSORSHIP_FAILURE: `${entity.name}/UPDATE_SPONSORSHIP_FAILURE`,
  UPDATE_SPONSORSHIP_REQUEST: `${entity.name}/UPDATE_SPONSORSHIP_REQUEST`,
  UPDATE_SPONSORSHIP_SUCCESS: `${entity.name}/UPDATE_SPONSORSHIP_SUCCESS`,
  ADD_SPONSORSHIP_ITEM_REQUEST: `${entity.name}/ADD_SPONSORSHIP_ITEM_REQUEST`,
  ADD_SPONSORSHIP_ITEM_SUCCESS: `${entity.name}/ADD_SPONSORSHIP_ITEM_SUCCESS`,
  ADD_SPONSORSHIP_ITEM_ERROR: `${entity.name}/ADD_SPONSORSHIP_ITEM_ERROR`,
  ADD_RECEIPT_ITEM: `${entity.name}/ADD_RECEIPT_ITEM`,
  GET_SPONSORSHIP_ITEMS_REQUEST: `${entity.name}/GET_SPONSORSHIP_ITEMS_REQUEST`,
  GET_SPONSORSHIP_ITEMS_SUCCESS: `${entity.name}/GET_SPONSORSHIP_ITEMS_SUCCESS`,
  GET_SPONSORSHIP_ITEMS_ERROR: `${entity.name}/GET_SPONSORSHIP_ITEMS_ERROR`,
  DELETE_SPONSORSHIP_ITEM_REQUEST: `${entity.name}/DELETE_SPONSORSHIP_ITEM_REQUEST`,
  DELETE_SPONSORSHIP_ITEM_SUCCESS: `${entity.name}/DELETE_SPONSORSHIP_ITEM_SUCCESS`,
  DELETE_SPONSORSHIP_ITEM_ERROR: `${entity.name}/DELETE_SPONSORSHIP_ITEM_ERROR`,
  GET_DYNAMIC_CLICKS_REQUEST: `${entity.name}/GET_DYNAMIC_CLICKS_REQUEST`,
  GET_DYNAMIC_CLICKS_SUCCESS: `${entity.name}/GET_DYNAMIC_CLICKS_SUCCESS`,
  GET_DYNAMIC_CLICKS_ERROR: `${entity.name}/GET_DYNAMIC_CLICKS_ERROR`,
  CLEAR_DYNAMIC_CLICKS_STATE: `${entity.name}/CLEAR_DYNAMIC_CLICKS_STATE`,
  GET_SPONSORSHIP_PARTNERS_REQUEST: `${entity.name}/GET_SPONSORSHIP_PARTNERS_REQUEST`,
  GET_SPONSORSHIP_PARTNERS_SUCCESS: `${entity.name}/GET_SPONSORSHIP_PARTNERS_SUCCESS`,
  GET_SPONSORSHIP_PARTNERS_ERROR: `${entity.name}/GET_SPONSORSHIP_PARTNERS_ERROR`,
  GET_SPONSORS_REQUEST: `${entity.name}/GET_SPONSORS_REQUEST`,
  GET_SPONSORS_SUCCESS: `${entity.name}/GET_SPONSORS_SUCCESS`,
  GET_SPONSORS_FAILURE: `${entity.name}/GET_SPONSORS_FAILURE`,
  CREATE_SPONSORSHIP_REQUEST: `${entity.name}/CREATE_SPONSORS_REQUEST`,
  CREATE_SPONSORSHIP_SUCCESS: `${entity.name}/CREATE_SPONSORS_SUCCESS`,
  CREATE_SPONSORSHIP_FAILURE: `${entity.name}/CREATE_SPONSORS_FAILURE`,
  CLEAR_STATE: `${entity.name}/CLEAR_STATE`,
  CLEAR_SPONSORSHIP_CART: `${entity.name}/CLEAR_SPONSORSHIP_CART`,
  GET_OVERVIEW_REPORT_REQUEST: `${entity.name}/GET_OVERVIEW_REPORT_REQUEST`,
  GET_OVERVIEW_REPORT_SUCCESS: `${entity.name}/GET_OVERVIEW_REPORT_SUCCESS`,
  GET_OVERVIEW_REPORT_FAILURE: `${entity.name}/GET_OVERVIEW_REPORT_FAILURE`,
  EXPIRED_SPONSORSHIPS_REQUEST: `${entity.name}/EXPIRED_SPONSORSHIPS_REQUEST`,
  EXPIRED_SPONSORSHIPS_SUCCESS: `${entity.name}/EXPIRED_SPONSORSHIPS_SUCCESS`,
  EXPIRED_SPONSORSHIPS_FAILURE: `${entity.name}/EXPIRED_SPONSORSHIPS_FAILURE`,
};

export const createCart = jobId => async (dispatch) => {
  dispatch({ type: TYPES.CREATE_CART_REQUEST });
  try {
    await entity.api.createCart(jobId);
    dispatch({ type: TYPES.CREATE_CART_SUCCESS });
  } catch (error) {
    dispatch({ type: TYPES.CREATE_CART_FAILURE, payload: { error } });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while creating a new cart. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while creating a new cart.', VARIANTS.INFO));
    }
    throw error;
  }
};

export const createSponsorship = options => async (dispatch) => {
  dispatch({ type: TYPES.CREATE_SPONSORSHIP_REQUEST });
  try {
    const data = await entity.api.createSponsorship(options);
    dispatch({ type: TYPES.CREATE_SPONSORSHIP_SUCCESS });
    return data;
  } catch (error) {
    dispatch({ type: TYPES.CREATE_SPONSORSHIP_FAILURE, payload: { error } });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while creating the sponsorship items. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while creating the sponsorship items.', VARIANTS.INFO));
    }
    throw error;
  }
};

export const clearState = () => (dispatch) => {
  dispatch({ type: TYPES.CLEAR_STATE });
};

export const clearSponsorshipCart = () => (dispatch) => {
  dispatch({ type: TYPES.CLEAR_SPONSORSHIP_CART });
};

export const addSponsorshipItem = (jobId, options) => async (dispatch) => {
  dispatch({ type: TYPES.ADD_SPONSORSHIP_ITEM_REQUEST });
  try {
    const data = await entity.api.addSponsorshipItem(jobId, options);
    const reduxData = data.reduce((acc, curr) => ({ ...acc,
      [curr.posting_id]: {
        posting_id: curr.posting_id,
        display_name: curr.display_name,
        price: curr.price,
        frequency: curr.frequency,
      } }), {});
    dispatch({ type: TYPES.ADD_SPONSORSHIP_ITEM_SUCCESS, payload: { data: reduxData } });
    return data;
  } catch (error) {
    dispatch({ type: TYPES.ADD_SPONSORSHIP_ITEM_ERROR, payload: { error } });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while adding the sponsorship partner. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while adding the sponsorship partner.', VARIANTS.INFO));
    }
    throw error;
  }
};

const addReceiptItem = payload => (dispatch) => {
  dispatch({ type: TYPES.ADD_RECEIPT_ITEM, payload });
};

export const getSponsorshipItems = jobId => async (dispatch) => {
  dispatch({ type: TYPES.GET_SPONSORSHIP_ITEMS_REQUEST });
  try {
    const data = await entity.api.getSponsorshipItems(jobId);
    const reduxData = data.reduce((acc, curr) => ({ ...acc,
      [curr.posting_id]: {
        posting_id: curr.posting_id,
        display_name: curr.display_name,
        price: curr.price,
        frequency: curr.frequency,
      } }), {});
    dispatch({ type: TYPES.ADD_SPONSORSHIP_ITEM_SUCCESS, payload: { data: reduxData } });
    return data;
  } catch (error) {
    dispatch({ type: TYPES.ADD_SPONSORSHIP_ITEM_ERROR, payload: { error } });
    throw error;
  }
};

export const deleteSponsorshipItem = (jobId, options) => async (dispatch) => {
  dispatch({ type: TYPES.DELETE_SPONSORSHIP_ITEM_REQUEST });
  try {
    const data = await entity.api.deleteSponsorshipItem(jobId, options);
    dispatch({ type: TYPES.DELETE_SPONSORSHIP_ITEM_SUCCESS, payload: { data: options.postingId } });
    return data;
  } catch (error) {
    dispatch({ type: TYPES.DELETE_SPONSORSHIP_ITEM_ERROR, payload: { error } });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while deleting the sponsorship partner. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while deleting the sponsorship partner.', VARIANTS.INFO));
    }
    throw error;
  }
};

export const getDynamicClickValues = price => async (dispatch) => {
  dispatch({ type: TYPES.GET_DYNAMIC_CLICKS_REQUEST });
  try {
    const data = await entity.api.getDynamicClickValues(price);
    dispatch({ type: TYPES.GET_DYNAMIC_CLICKS_SUCCESS, payload: { data } });
    return data;
  } catch (error) {
    dispatch({ type: TYPES.GET_DYNAMIC_CLICKS_ERROR, payload: { error } });
    throw error;
  }
};

export const getSponsorshipPartners = jobId => async (dispatch) => {
  dispatch({ type: TYPES.GET_SPONSORSHIP_PARTNERS_REQUEST });

  try {
    const data = await entity.api.getSponsorshipPartners(jobId);
    dispatch({ type: TYPES.GET_SPONSORSHIP_PARTNERS_SUCCESS, payload: { data } });
    return data;
  } catch (error) {
    dispatch({ type: TYPES.GET_SPONSORSHIP_PARTNERS_ERROR, payload: { error } });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while fetching the sponsorship partners. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while fetching the sponsorship partners.', VARIANTS.INFO));
    }
    throw error;
  }
};

export const clearDynamicClicksState = (dispatch) => {
  dispatch({ type: TYPES.CLEAR_DYNAMIC_CLICKS_STATE });
};

export const updateJobSponsorship = data => async (dispatch, getState) => {
  dispatch({ type: TYPES.UPDATE_SPONSORSHIP_REQUEST });
  try {
    const profileKey = getProfileKey(getState());
    const response = await entity.api.updateJobSponsorship(data, profileKey);
    const sponsorship = response?.data;
    dispatch({ type: TYPES.UPDATE_SPONSORSHIP_SUCCESS, payload: { [sponsorship.id]: sponsorship } });
    return response;
  } catch (error) {
    dispatch({ type: TYPES.UPDATE_SPONSORSHIP_FAILURE, payload: error });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while updating the job sponsorship. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while updating the job sponsorship.', VARIANTS.INFO));
    }
    throw error;
  }
};

export const getJobSponsor = options => async (dispatch) => {
  dispatch({ type: TYPES.GET_SPONSORS_REQUEST });

  try {
    const response = await entity.api.getJobSponsor({ ...options });
    const data = response?.data;
    const jobId = options?.jobId;
    dispatch({ type: TYPES.GET_SPONSORS_SUCCESS, payload: { [jobId]: data } });
    return response;
  } catch (error) {
    dispatch({ type: TYPES.GET_SPONSORS_FAILURE, payload: error });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while fetching the job sponsorships. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while fetching the job sponsorships.', VARIANTS.INFO));
    }
    throw error;
  }
};

export const getOverviewReport = (orgId, options, ctx) => async (dispatch) => {
  dispatch({ type: TYPES.GET_OVERVIEW_REPORT_REQUEST });
  try {
    const response = await entity.api.getOverviewReport(orgId, options, ctx);
    const data = response?.data;
    dispatch({ type: TYPES.GET_OVERVIEW_REPORT_SUCCESS, payload: data });
    return response;
  } catch (error) {
    dispatch({ type: TYPES.GET_OVERVIEW_REPORT_FAILURE, payload: error });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while fetching the organization overview report. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while fetching the organization overview report.', VARIANTS.INFO));
    }
    throw error;
  }
};
export const getExpiredJobSponsorships = options => async (dispatch) => {
  dispatch({ type: TYPES.EXPIRED_SPONSORSHIPS_REQUEST });
  try {
    const response = await entity.api.getExpiredJobSponsorships({ ...options });
    const data = response?.data;
    dispatch({ type: TYPES.EXPIRED_SPONSORSHIPS_SUCCESS, payload: data });
    return response;
  } catch (error) {
    dispatch({ type: TYPES.EXPIRED_SPONSORSHIPS_FAILURE, payload: error });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while fetching the expired job sponsorships. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while fetching the expired job sponsorships.', VARIANTS.INFO));
    }
    throw error;
  }
};

export default {
  TYPES,
  createCart,
  addSponsorshipItem,
  addReceiptItem,
  getSponsorshipItems,
  deleteSponsorshipItem,
  getDynamicClickValues,
  clearDynamicClicksState,
  getSponsorshipPartners,
  updateJobSponsorship,
  getJobSponsor,
  createSponsorship,
  clearState,
  clearSponsorshipCart,
};
